import classNames from 'classnames'
import { FC, PropsWithChildren } from 'react'

type BtnProps = {
  onClick: React.MouseEventHandler<HTMLButtonElement>
  type?: 'normal' | 'neon'
  disabled?: boolean
}

export const Button: FC<PropsWithChildren & BtnProps> = ({
  type = 'normal',
  disabled,
  onClick,
  children,
}) => {
  return (
    <button
      className={classNames({
        'relative h-10 w-full px-4 py-2 rounded-[30px] z-[1]': true,
        'bg-norBtn font-notoSans font-medium text-sm leading-6 text-nortextBtn shadow-btnCustom':
          type === 'normal',
        'font-lineSeed font-bold text-lg leading-6 text-black bg-no-repeat bg-[length:100%_100%]':
          type === 'neon',
        'bg-btnNeonGif': type === 'neon' && !disabled,
        'bg-btnNeonDisable': type === 'neon' && disabled,
      })}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
